import { differenceInSeconds } from 'date-fns';
import { Subject, Subscription, timer } from 'rxjs';

import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';

const MINUTE = 60;
const HOUR = MINUTE * 60;

@Pipe({
  name: 'fsTimeDuration',
  pure: false,
})
export class FsTimeDurationPipe implements PipeTransform, OnDestroy {
  private _date: number;
  private _value: string = '00:00';

  private _clockSubscription: Subscription;

  private readonly _stateChange$ = new Subject<void>();

  constructor(changeDetectorRef: ChangeDetectorRef) {
    this._stateChange$.subscribe(() => {
      const timeDifference = differenceInSeconds(Date.now(), this._date);

      const hours = Math.floor(timeDifference / HOUR);
      const minutes = Math.floor((timeDifference - hours * HOUR) / MINUTE);
      const seconds = Math.floor(timeDifference - hours * HOUR - minutes * MINUTE);

      const minuteString = minutes.toString().padStart(2, '0');
      const secondString = seconds.toString().padStart(2, '0');

      if (hours) {
        this._value = `${hours}:${minuteString}:${secondString}`;
      } else {
        this._value = `${minuteString}:${secondString}`;
      }
      changeDetectorRef.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    if (this._clockSubscription) {
      this._clockSubscription.unsubscribe();
      this._clockSubscription = null;
    }

    this._stateChange$.complete();
  }

  public transform(value: Date): string {
    if (!value) {
      return;
    }

    const date = new Date(value).valueOf();

    if (isNaN(date)) {
      return;
    }

    if (this._date === date) {
      return this._value;
    }

    this._date = date;

    if (this._clockSubscription) {
      this._clockSubscription.unsubscribe();
      this._clockSubscription = null;
    }

    if (this._date) {
      this._clockSubscription = timer(0, 1000).subscribe(() => {
        this._stateChange$.next();
      });
    } else {
      throw new SyntaxError(`
        Wrong parameter in FsTimeDurationPipe.
        Expected a valid date, received: ${date}
      `);
    }

    return this._value;
  }
}
